export default "__VITE_ASSET__BHgb9ZHH__"